import type { RiskLevel } from '../api/types'

export function isCriticalRisk(item: { risk_level: RiskLevel }): boolean {
  return item.risk_level === 'CRITICAL'
}
